﻿require('jquery-validation');
require('jquery-validation-unobtrusive');

(function ($) {
    if ($.validator && $.validator.unobtrusive) {
        var defaultOptions = {
            validClass: 'is-valid',
            errorClass: 'is-invalid',
            highlight: function (element, errorClass, validClass) {
                $(element)
                    .removeClass(validClass)
                    .addClass(errorClass);
            },
            unhighlight: function (element, errorClass, validClass) {
                $(element)
                    .removeClass(errorClass)
                    .addClass(validClass);
            }
        };

        $.validator.setDefaults(defaultOptions);

        $.validator.unobtrusive.options = {
            errorClass: defaultOptions.errorClass,
            validClass: defaultOptions.validClass,
            errorElement: 'div',
            errorPlacement: function (error, element) {
                error.addClass('invalid-feedback');

                if (element.next().is(".input-group-append")) {
                    error.insertAfter(element.next());
                } else {
                    error.insertAfter(element);
                }
            }
        };

        $.validator.addMethod('uniquein',
            function (value, element, params) {

                let $form = $(element).closest('form');
                if ($form.length === 0)
                    return true;

                let isValid = true;
                let $compareTo = $(params, $form);

                $compareTo.each(function () {
                    if ((this !== element) && (value === $(this).val())) {
                        isValid = false;
                        return false;
                    }
                });

                return isValid;
            });

        $.validator.unobtrusive.adapters.add('uniquein', ['selector'], function (options) {
            options.rules['uniquein'] = options.params.selector;
            options.messages['uniquein'] = options.message;
        });

    }
    else {
        console.warn('$.validator is not defined. Please load this library **after** loading jquery.validate.js and jquery.validate.unobtrusive.js');
    }
})(jQuery);
